import DocumentLines from "./DocumentLines";
import DocumentLogo from "./DocumentLogo";
import DocumentCust from "./DocumentCust";
import DocumentRef from "./DocumentRef";
import formatMoney from "../../../../../utils/formatMoney";
import Moment from "react-moment";

export default function DocumentWrapper({ selected, pageno, pages }: any) {
  const total = selected?.quoteitems?.reduce(
    (prev: any, curr: any) => prev + curr.net_total,
    0
  );

  const parts = total * 0.7;
  const labor = total * 0.3;
  const withholding = labor * 0.05;

  return (
    <div className="flex justify-center" id="invoice-doc">
      <div className="p-1 w-full">
        <DocumentLogo />
        <DocumentRef
          title="Service Quote"
          date={new Date()}
          selected={selected}
        />
        <DocumentCust customer={selected} pageno={pageno} pages={pages} />

        <div className="mb-8">
          <div className="border border-black  mt-2 text-xs">
            <div className="grid grid-cols-12 border-b  border-black  bg-gray-200">
              <div className="col-span-4 p-1 text-center">Model & Make</div>
              <div className="col-span-2 p-1 text-center">Chassis No.</div>
              <div className="col-span-2 p-1 text-center">Engine No.</div>
              <div className="col-span-2 p-1 text-center">Mileage</div>
              <div className="col-span-2 p-1 text-center">Date</div>
            </div>
            <div className="grid grid-cols-12   border-black  bg-white">
              <div className="col-span-4 p-1 text-center">
                {selected?.vehicle_model} {selected?.vehicle_type}
              </div>
              <div className="col-span-2 p-1 text-center"></div>
              <div className="col-span-2 p-1 text-center"></div>
              <div className="col-span-2 p-1 text-center">
                {selected?.vehicle_mileage}
              </div>
              <div className="col-span-2 p-1 text-center">
                <Moment format="Do MMM, YYYY">{selected?.createdAt}</Moment>
              </div>
            </div>
            <div className="grid grid-cols-12 border-b border-t  border-black  bg-gray-200">
              <div className="col-span-4 p-1 text-center">Reference No.</div>
              <div className="col-span-2 p-1 text-center">Reg No.</div>
              <div className="col-span-2 p-1 text-center">Reg Date</div>
              <div className="col-span-2 p-1 text-center">VSB</div>
              <div className="col-span-2 p-1 text-center">WIP</div>
            </div>
            <div className="grid grid-cols-12   border-black  bg-white">
              <div className="col-span-4 p-1 text-center">
                {selected?.customer_code
                  ? selected?.customer_code
                  : selected?.customer_id}
              </div>
              <div className="col-span-2 p-1 text-center"></div>
              <div className="col-span-2 p-1 text-center"></div>
              <div className="col-span-2 p-1 text-center"></div>
              <div className="col-span-2 p-1 text-center"></div>
            </div>
          </div>
        </div>

        <DocumentLines
          items={selected?.quoteitems}
          currencyFormatter={formatMoney}
        />
        {pageno === pages ? (
          <div className="border border-black  text-xs">
            <div className="grid grid-cols-12 border-t  border-black  bg-white">
              <div className="col-span-4 p-1  text-left">
                <div>Dear Customer,</div>
                <div>For your next service or repair</div>
                <div>Please contact us for an appointment</div>
                <div>Your cooperation is shighly appreciated.</div>
              </div>
              <div className="col-span-4  border-r border-black">
                <div className="flex justify-between border-b border-l border-black p-1">
                  <div className="">Withholding Tax</div>
                  {/* <div className="">{formatMoney(Math.round(withholding))}</div> */}
                  <div className="">-</div>
                </div>
                <div className="flex justify-between px-1">
                  <div className="">Total Parts</div>
                  <div className="">-</div>
                  {/* <div className="">{formatMoney(Math.round(parts))}</div> */}
                </div>
                <div className="flex justify-between px-1">
                  <div className="">Total Labor</div>
                  <div className="">-</div>
                  {/* <div className="">{formatMoney(Math.round(labor))}</div> */}
                </div>
              </div>
              <div className="col-span-4 py-1 font-semibold p-2">
                <div className="flex justify-between">
                  <div className="">Nett</div>
                  <div className="">
                    {formatMoney(Math.round(total * 0.82))}
                  </div>
                </div>
                <div className="flex justify-between">
                  <div className="">V.A.T</div>
                  <div className="">
                    {formatMoney(Math.round(total * 0.18))}
                  </div>
                </div>
                <div className="flex justify-between">
                  <div className="">Total</div>
                  <div className="">{formatMoney(Math.round(total))}</div>
                </div>
                <div className="flex justify-between">
                  <div className="">Paid</div>
                  <div className="">{formatMoney(0)}</div>
                </div>
                <div className="flex justify-between font-extrabold">
                  <div className="">Owing</div>
                  <div className="">{formatMoney(Math.round(total))}</div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        <div className="mt-2 flex text-xs">
          <div className="font-bold">Note:</div>
          <div className="ml-2">
            This cost covers only preventive maintanance parts i.e filters,
            lubricants and labour cost
          </div>
        </div>
      </div>
    </div>
  );
}
